angular.
module("dx.webapp.api").
factory("dxApiV1LoginCode", function apiV1LoginCodeService(
	$http,
	$location
) {
	"use strict";

	var regionMap = {
		"app.digiexam.com": "eu",
		"digiexam-live.appspot.com": "eu",
		"app-us.digiexam.com": "us",
		"digiexam-live-us.appspot.com": "us",
		"digiexam-release.appspot.com": "staging",
		"digiexam-demo.appspot.com": "dev",
		"digiexam-manual.appspot.com": "dev",
	};

	function getBaseUrl() {
		var region = regionMap[$location.host()] || "dev";
		return "https://assignment.api." + region + ".digiexam.com";
	}

	function authHeaders(authToken) {
		return {headers: {Authorization: "Bearer " + authToken}};
	}

	function getActive(authToken) {
		return $http.get(
			getBaseUrl() + "/api/v1/login-code/get",
			authHeaders(authToken)
		).then(function success(response) {
			return response.data;
		});
	}

	function generate(authToken) {
		return $http.post(
			getBaseUrl() + "/api/v1/login-code/generate",
			{digit_code: true}, // eslint-disable-line camelcase
			authHeaders(authToken)
		).then(function success(response) {
			return response.data;
		});
	}

	function generateStudent(authToken, studentId) {
		return $http.post(
			getBaseUrl() + "/api/v1/login-code/generate-student",
			{student_id: studentId, digit_code: true}, // eslint-disable-line camelcase
			authHeaders(authToken)
		).then(function success(response) {
			return response.data;
		});
	}

	return {
		getActive: getActive,
		generate: generate,
		generateStudent: generateStudent,
	};
});
